




































































































































































































import { Component, Vue, Emit, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import ChatStore from '@/components/Chat/Store/ChatStore'
import { AlteracaoDataMensagem, Snackbar, RequestMessage, IRequestMessage, AlteracaoDataAgendamento } from '@/types/_'
import Theme from '@/styles/Theme'
import { DateTime } from 'luxon'
import { maskDateTime, timeoutDefault, maskDate } from '@/utils/common'
import moment from 'moment'
import EventBus from '@/plugins/EventBus'

@Component

export default class ModalSolicitacaoAlteracaoDataAgendamento extends Vue {
  @Prop() tipoUsarioHospital: boolean
  @Prop() solicitacaoId: string

  $refs: {
    dateA: any,
    dateB: any,
    dateC: any,
    agendamentoChat: any,
  }

  loadClose: boolean = false

  get loadingClose() {
    return this.loadClose
  }

  set loadingClose(value: boolean) {
    this.loadClose = value
  }

  windowHeight: number = 0
  mensagem: string = ''
  mensagemError: any = {
    dateText1: '',
    dateText2: '',
    dateText3: '',
  }

  snackBar: Snackbar = {
    disabled: false,
    disabledBtn: false,
    show: false,
    timeout: 6000,
    message: 'Houver um erro ao enviar a mensagem.',
    color: '#d3f2f2',
  }

  date1: string = ''
  date2: string = ''
  date3: string = ''

  dateText1: string = ''
  dateText2: string = ''
  dateText3: string = ''

  modalHeight: number = 0

  get getSolicitacaoPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get getChatStore() {
    return getModule(ChatStore, this.$store)
  }

  get getDateText1() {
    this.dateText1 = this.formatISOToDate(this.date1)
    return this.dateText1
  }

  set getDateText1(value: string | Date) {
    this.dateText1 = this.formatISOToDate(this.date1)
  }

  get getDateText2() {
    this.dateText2 = this.formatISOToDate(this.date2)
    return this.dateText2
  }

  set getDateText2(value: string | Date) {
    this.dateText2 = this.formatISOToDate(this.date2)
  }

  get getDateText3() {
    this.dateText3 = this.formatISOToDate(this.date3)
    return this.dateText3
  }

  set getDateText3(value: string | Date) {
    this.dateText3 = this.formatISOToDate(this.date3)
  }

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get getSolicitacaoCirurgiaStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  get showModal() {
    const show = this.getSolicitacaoStore.modalSolicitacaoCirurgia.showAlteracaoDataSolicitada
    if (show) {
      this.modalIsOpened()
    } else {
      this.modalIsClosed()
    }
    return show
  }

  set showModal(value: boolean) {
    this.getSolicitacaoStore.setShowAlteracaoDataAgendamento(value)
  }

  get getTheme() {
    return Theme
  }

  get getMensagem() {
    return this.mensagem
  }

  set getMensagem(value: string) {
    this.mensagem = value
  }

  getDateFormat() {
    return DateTime.local().toFormat('yyyy-LL-ddT12:00')
  }

  positionRight(mensagemHospital: boolean) {
    return this.tipoUsarioHospital === mensagemHospital
  }

  positionLeft(mensagemHospital: boolean) {
    return this.tipoUsarioHospital !== mensagemHospital
  }

  clearDate(elements: string[]) {
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i]
      this[element] = ''
    }
  }

  clickDateTimeA(event) {
    if (!this.date1) {
      this.date1 = moment(new Date()).format('YYYY-MM-DDT12:00')
    }

    this.$refs.dateA.open(event)
  }

  clickDateTimeB(event) {
    if (!this.date2) {
      this.date2 = moment(new Date()).format('YYYY-MM-DDT12:00')
    }

    this.$refs.dateB.open(event)
  }

  clickDateTimeC(event) {
    if (!this.date3) {
      this.date3 = moment(new Date()).format('YYYY-MM-DDT12:00')
    }
    this.$refs.dateC.open(event)
  }

  formatISOToDate(value: string | Date) {
    if (value === '') return value
    return DateTime.fromISO(value).toLocaleString(DateTime.DATETIME_MED)
  }

  formatHour(date) {
    return maskDateTime(date)
  }

  formatDate(date) {
    return maskDate(date)
  }

  isValid() {
    let valid: boolean = true
    this.mensagemError.dateText1 = ''

    if (!this.dateText1) {
      this.mensagemError.dateText1 = 'Por favor informe a data e hora.'
      return false
    }

    this.mensagemError.dateText1 = ''
    this.mensagemError.dateText2 = ''
    this.mensagemError.dateText3 = ''

    if (this.date1 === this.date2 && this.date1 === this.date3) {
      this.mensagemError.dateText1 = 'As datas não podem ser iguais.'
      this.mensagemError.dateText2 = 'As datas não podem ser iguais.'
      this.mensagemError.dateText3 = 'As datas não podem ser iguais.'
      valid = false
    } else if (this.date1 === this.date2) {
      this.mensagemError.dateText1 = 'As datas não podem ser iguais.'
      this.mensagemError.dateText2 = 'As datas não podem ser iguais.'
    } else if (this.date1 === this.date3) {
      this.mensagemError.dateText1 = 'As datas não podem ser iguais.'
      this.mensagemError.dateText3 = 'As datas não podem ser iguais.'
    } else if (this.date2 === this.date3) {
      this.mensagemError.dateText2 = 'As datas não podem ser iguais.'
      this.mensagemError.dateText3 = 'As datas não podem ser iguais.'
    }

    if (!this.date1) {
      this.mensagemError.dateText1 = ''
    }

    if (!this.date2) {
      this.mensagemError.dateText2 = ''
    }
    if (!this.date3) {
      this.mensagemError.dateText3 = ''
    }

    return valid
  }

  get configuracoes() {
    const { configuracoes } = this.getSolicitacaoPendenciaStore.agendamentoMedico
    return configuracoes || { prazoEmDiasParaTriagem: 0, prazoMaximoEmDiasParaAgendamento: 0 }
  }

  get prazoParaTriagem() {
    return this.configuracoes && this.configuracoes.prazoMaximoEmDiasParaAgendamento && this.configuracoes.prazoMaximoEmDiasParaAgendamento > 0
      ? moment().add(this.configuracoes.prazoMaximoEmDiasParaAgendamento, 'days').format('YYYY-MM-DD')
      : moment().add(10, 'years').format('YYYY-MM-DD')
  }

  diferencaDeDatas(dataSelecionada: Date | string, prazo: number) {
    const hoje = moment().format('YYYY-MM-DD')
    const dataSelececionadaFormatada = moment(dataSelecionada).format('YYYY-MM-DD')
    return Math.floor(moment.duration(moment(hoje).add(prazo, 'days').diff(moment(dataSelececionadaFormatada))).asDays()) >= 0
  }

  verificaPrazoParaTriagem() {
    const datas = []
    const datasValidas: any = {
      opcaoDeData1: DateTime.fromISO(this.date1).setZone('America/Sao_Paulo').toISO(),
      opcaoDeData2: this.date2 ? DateTime.fromISO(this.date2).setZone('America/Sao_Paulo').toISO() : null,
      opcaoDeData3: this.date3 ? DateTime.fromISO(this.date3).setZone('America/Sao_Paulo').toISO() : null,
    }

    Object.entries(datasValidas).forEach(([key, value]) => {
      if (['', null, undefined].includes(value as any)) delete datasValidas[key]
    })

    Object.entries(datasValidas).forEach(([key]) => {
      // @ts-ignore
      datas.push(this.diferencaDeDatas(datasValidas[key], this.configuracoes.prazoEmDiasParaTriagem))
    })

    return datas.some((e: boolean) => e)
  }

  async alterarData() {
    if (this.getSolicitacaoCirurgiaStore.modal.previaCirurgica) {
      this.getSolicitacaoCirurgiaStore.setModal({ name: 'previaCirurgica', value: false })
    }

    this.setLoadingRequest(true, this.getSolicitacaoStore.requestMessage.avancar.text)

    const alterarDataAgendamento: AlteracaoDataAgendamento = {
      solicitacaoId: this.solicitacaoId,
      opcao1: DateTime.fromISO(this.date1).setZone('America/Sao_Paulo').toISO(),
      opcao2: this.date2 ? DateTime.fromISO(this.date2).setZone('America/Sao_Paulo').toISO() : null,
      opcao3: this.date3 ? DateTime.fromISO(this.date3).setZone('America/Sao_Paulo').toISO() : null,
      dataConfirmada: '',
    }

    const response = await this.getSolicitacaoStore.postAlteracaoDataAgendamento(alterarDataAgendamento)

    if (response.success) {
      this.getSolicitacaoStore.setShowAlteracaoDataAgendamento(false)
      this.getChatStore.clearAlteracaoDataAgendamento()
      this.clear()
    } else {
      this.snackBar.show = true
      this.snackBar.disabled = true
      this.snackBar.color = '#d3f2f2'
      this.snackBar.message = response.message || 'Houver um erro ao enviar a mensagem.'
      this.getSolicitacaoStore.setSnackbar(this.snackBar)
    }

    this.clearLoadingRequest()
  }

  async confirmar() {
    if (this.isValid()) {
      if (this.configuracoes.prazoEmDiasParaTriagem > 0 && !this.verificaPrazoParaTriagem()) {
        this.getSolicitacaoCirurgiaStore.setModal({ name: 'previaCirurgica', value: true })
        return
      }

      await this.alterarData()
    }
  }

  clear() {
    this.getSolicitacaoStore.clearAlteracaoDataAgendamento()
    this.getMensagem = ''
    this.getDateText1 = ''
    this.getDateText2 = ''
    this.getDateText3 = ''
    this.date1 = ''
    this.date2 = ''
    this.date3 = ''
    this.mensagemError = {
      dateText1: '',
      dateText2: '',
      dateText3: '',
    }
  }

  async closeModal() {
    this.loadingClose = true
    await timeoutDefault()
    this.getSolicitacaoStore.setShowAlteracaoDataAgendamento(false)
    this.clear()
    this.loadingClose = false
  }

  scrollToMensagem() {
    const ele = document.getElementsByClassName('main-chat-scroll')
    const option: ScrollToOptions = {
      behavior: 'smooth',
      left: 0,
      top: ele[0].scrollHeight + 200,
    }
    ele[0].scrollTo(option)
  }

  getWindowHeight() {
    const doc: Document = document

    if (doc !== null) {
      const documentHeight = doc.documentElement.clientHeight
      this.windowHeight = documentHeight
      const documentWidth = doc.documentElement.clientWidth
      const modalMain = (doc.querySelector('.modal-alterar-data__main') as HTMLDivElement).scrollHeight
      const modalToolbar = (doc.querySelector('.modal-alterar-data__toolbar') as HTMLDivElement).scrollHeight
      const modalHeader = (doc.querySelector('.modal-alterar-data__header') as HTMLDivElement).scrollHeight
      const modalActions = (doc.querySelector('.modal-alterar-data__actions') as HTMLDivElement).scrollHeight
      const chatInput = (doc.querySelector('.main-chat__send') as HTMLDivElement).scrollHeight
      const variation = !this.getDeviceOrientation() ? 46 : 90
      this.modalHeight = modalMain - modalToolbar - modalActions - modalHeader - chatInput - variation
    } else {
      this.modalHeight = 0
    }
  }

  async mounted() {
    await this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowHeight)
      window.addEventListener('orientationchange', this.getDeviceOrientation)
      this.getWindowHeight()
      this.getDeviceOrientation()
    })
  }

  async updated() {
    await this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowHeight)
      window.addEventListener('orientationchange', this.getDeviceOrientation)
      this.getWindowHeight()
      this.getDeviceOrientation()
    })
    this.scrollToMensagem()
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowHeight)
  }

  getDeviceType() {
    const ua = window.navigator.userAgent
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return 'tablet'
    }
    if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
      return 'mobile'
    }
    return 'desktop'
  }

  handleOrientationChange() {
    return window.screen.orientation.type
  }

  getDeviceOrientation() {
    const orientation = this.handleOrientationChange() === 'landscape-primary'
    const type = this.getDeviceType() === 'mobile'
    return orientation && type
  }

  clearLoadingRequest() {
    this.setLoadingRequest(false, '')
  }


  modalIsOpened() {
    const html = document.querySelector('html')
    const noOverflowClass = 'modal-is-open'
    if (html) {
      html.classList.add(noOverflowClass)
    }
  }

  modalIsClosed() {
    const html = document.querySelector('html')
    const noOverflowClass = 'modal-is-open'
    if (html) {
      html.classList.remove(noOverflowClass)
    }
  }

  @Emit('setLoadingRequest')
  setLoadingRequest(status, text) { }

  loadMensagem: boolean = false

  get loadingMensagem() {
    return this.loadMensagem
  }

  set loadingMensagem(value: boolean) {
    this.loadMensagem = value
  }

  get placeholder() {
    return this.getDateText1 === '' ? 'Escolha uma data para poder digitar uma mensagem...' : 'Mensagem'
  }

  clearMensagem() {
    this.getMensagem = ''
  }

  async send() {
    const responseMessage: IRequestMessage = new RequestMessage()
    this.loadingMensagem = true
    const mensagem: AlteracaoDataMensagem = {
      mensagemHospital: this.tipoUsarioHospital,
      hospitalId: '',
      dataEnvio: DateTime.local().toISO(),
      mensagem: this.$sanitize(this.getMensagem),
    }

    this.getMensagem = ''
    const response = await this.getChatStore.sendDataAgendamentoMensagem(mensagem)

    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    this.loadingMensagem = false
  }
}

